import React from "react";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const MenuDropdownContext = React.createContext(null);
export function usePortalContainer(menuState) {
    const ref = React.useRef(null);
    if (menuState === "opening") {
        ref.current = document.activeElement?.closest("dialog") ?? document.body;
    }
    return ref.current ?? document.activeElement?.closest("dialog") ?? document.body;
}
